import { Component, OnInit, ViewChild, HostListener } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MatDrawer } from "@angular/material";

@Component({
  selector: "jps-portfolio",
  templateUrl: "./portfolio.component.html",
  styleUrls: ["./portfolio.component.scss"],
})
export class PortfolioComponent implements OnInit {
  screenWidth: number;
  private screenWidth$ = new BehaviorSubject<number>(window.innerWidth);
  @ViewChild("sidenav", { static: true }) sidenav: MatDrawer;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth$.next(event.target.innerWidth);
  }
  constructor() {}

  ngOnInit() {
    this.screenWidth$.subscribe((width) => {
      this.screenWidth = width;
    });
  }
}
